import { css } from "@emotion/core";
import { color } from "../../constants/commons";

export const basicLayoutStyles = (background?: string) => css`
  ${background && `background: ${background}`};
  position: relative;
  .partner-page-footer-layout {
    background: linear-gradient(
      0deg,
      ${color.white} 0%,
      ${color.whitishGray} 100%
    );
  }
  .footer-layout {
    background: linear-gradient(
      180deg,
      ${color.white} 0%,
      ${color.whitishGray} 100%
    );
  }
  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    .footer-container-padding {
      padding: 0 0.6em;
    }
  }
  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
    .footer-container-padding {
      padding: 0 1.5em;
    }
  }
  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .footer-container-padding {
      padding: 0 2em;
    }
  }
  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
    .footer-container-padding {
      padding: 0 5em;
    }
    padding-top: 3.9em;
  }
  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    .footer-container-padding {
      padding: 0 10em;
      max-width: 102em;
      margin: auto;
    }
    padding-top: 3.9em;
  }
`;
